import {ThemeDefinition} from '@volkswagen-onehub/components-core';
import {TariffsFeatureAppTheme} from '@volkswagen-onehub/whitelabel-e-mobility-tariffs-feature-app';

export function createTariffsFeatureAppThemeV26(
  theme: ThemeDefinition
): TariffsFeatureAppTheme {
  return {
    colors: {
      app: {
        background: theme.colors.background.primary,
      },
      tile: {
        headline: {
          background: theme.colors.content.primary,
        },
        information: {
          background: theme.colors.background.tertiary,
          content: {
            secondary: theme.colors.content.secondary,
          },
        },
        shadow: theme.colors.shadow.small,
      },
    },
    spacing: {
      appLayout: {
        blockEnd: theme.size.static600,
        blockGap: theme.size.grid001,
      },
      tariffsLayout: {
        marginTop: theme.size.dynamic0200,
        marginBottom: theme.size.dynamic0200,
      },
      tariffsHeader: {
        paddingLeftRight: 'var(--header-padding-left-right)',
      },
      tariffsContentLayout: {
        inlineStart: 'var(--tariffs-content-inline-start)',
        inlineEnd: 'var(--tariffs-content-inline-end)',
        marginTop: {
          mobile: theme.size.static350,
          desktop: theme.size.static450,
        },
      },
      tile: {
        headline: {
          paddingTop: theme.size.static250,
          paddingRight: theme.size.static400,
        },
        information: {
          padding: theme.size.static400,
          gap: theme.size.static350,
          header: {
            gap: theme.size.static150,
            paddingBottom: theme.size.static350,
          },
        },
        buttons: {
          padding: theme.size.static400,
          gap: theme.size.static300,
        },
        borderRadius: theme.size.borderRadius.cardS,
      },
    },
  };
}
